import Layout from "./Layout.jsx";
import MaterialManagement from "../components/MaterialManagement.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMe } from "../features/authSlice.js";

function MaterialManagementPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => { dispatch(getMe()); }, [dispatch]);
  useEffect(() => { if (isError) navigate("/"); }, [isError, navigate]);

  return (
    <>
      {user && (
        <Layout>
          <MaterialManagement />
        </Layout>
      )}
    </>
  );
}

export default MaterialManagementPage;
